import { FileUploadInterface } from './Profile';

export interface DeliveryRequest {
  id: string;
  itemGroupId: string;
  itemId: string;
  element: string;
  assetName: string;
  numberOfElement: string;
  borrowerCode: string;
  borrowerName: string;
  borrowerAddress: string;
  borrowerPhoneNumber: string;
  borrowerEmail: string;
  dateRequestRaised: string;
  dateOrderRegistered: string;
  dateOfDelivery: string;
  dateOfReturn: string;
  movementTo: string;
  movementReason: string;
  purpose: string;
  movementType: string;
  pickerName: string;
  pickerPhoneNumber: string;
  modeOfPayment: string;
  currency: string;
  amount: string;
  isApproved: boolean;
  approvalOrDenialComments: string;
  attention: string;
  phone: string;
  shipVia: string;
  shipPriority: string;
  airWay: string;
  account: string;
  pickupBy: string;
  pickupByID: string;
  pickupOn: string;
  shipTo: string;
  isOrderCreated: boolean;
  isActive: boolean;
  orderRequest: boolean;
  isPickerAssigned: boolean;
  isBilled: boolean;
  isShipped: boolean;
  files: FileUploadInterface[];
}

export interface ShippingRequest {
  id: string;
  asset_ID: string;
  assetTypeId: string;
  assetType: string;
  assetName: string;
  print: string;
  vault: string;
  elementId: string;
  elementType: string;
  shipping_Date: string; // ISO date
  return_Date: string;
  theatreName: string;
  theatreId: string;
  theatreContactPerson: string;
  theatreContactNo: string;
  theatreAddressLine1: string;
  theatreAddressLine2: string;
  theatreCity: string;
  theatreStateCode: string;
  theatrePostalCode: string;
  theatreCountryCode: string;
  carrierName: string;
  carrierAccount: string;
  requestBy: string;
  requesterEmailId: string;
  associatedAssets: string;
  notes: string;
  isCustomerRequestCompleted: boolean;
  templateName: string;
  templateId: string;
  taskAssignedDate: string;
  isShipperCompleted: boolean;
  isApproved: boolean;
  packageType: string;
  serviceType: string;
  paymentType: string;
  shippingContactName: string;
  shippingContactNo: string;
  shippingAddress1: string;
  shippingAddress2: string;
  shippingCity: string;
  shippingStateCode: string;
  shippingPostalCode: string;
  shippingCountryCode: string;
  shippingCarrierName: string;
  shippingCarrierAccount: string;
  pickType: string;
  trackingNo: string;
  trackingResponse: string;
  isShippingPrepCompleted: boolean;
  fedexURL: string;
  taskURL: string;
  pickupOn: string;
  isShippingCompleted: boolean;
  requestType: string;
  customerName: string;
  isActive: boolean;
  orderRequest: boolean;
  isCustomerServiceRequest: boolean;
  isAssigned: boolean;
  isExternal: boolean;
  isServiceCompleted: boolean;
  isRetured: boolean;
  assignedTo: string;
  shippingReason: string;
}

export const DeliveryRequestInitialState: DeliveryRequest = {
  id: '',
  itemGroupId: '',
  itemId: '',
  element: '',
  assetName: '',
  numberOfElement: '',
  borrowerCode: '',
  borrowerName: '',
  borrowerAddress: '',
  borrowerPhoneNumber: '',
  borrowerEmail: '',
  dateRequestRaised: '',
  dateOrderRegistered: '',
  dateOfDelivery: '',
  dateOfReturn: '',
  movementTo: '',
  movementReason: '',
  purpose: '',
  movementType: '',
  pickerName: '',
  pickerPhoneNumber: '',
  modeOfPayment: '',
  currency: '',
  amount: '',
  isApproved: false,
  approvalOrDenialComments: '',
  attention: '',
  phone: '',
  shipVia: '',
  shipPriority: '',
  airWay: '',
  account: '',
  pickupBy: '',
  pickupByID: '',
  pickupOn: '',
  shipTo: '',
  isActive: false,
  orderRequest: false,
  isOrderCreated: false,
  isPickerAssigned: false,
  isBilled: false,
  isShipped: false,
  files: [],
};

export const ShippingRequestInitialState: ShippingRequest = {
  id: '',
  asset_ID: '',
  assetTypeId: '',
  assetType: '',
  assetName: '',
  print: '',
  vault: '',
  elementId: '',
  elementType: '',
  shipping_Date: '',
  return_Date: '',
  theatreName: '',
  theatreId: '',
  theatreContactPerson: '',
  theatreContactNo: '',
  theatreAddressLine1: '',
  theatreAddressLine2: '',
  theatreCity: '',
  theatreStateCode: '',
  theatrePostalCode: '',
  theatreCountryCode: '',
  carrierName: '',
  carrierAccount: '',
  requestBy: '',
  requesterEmailId: '',
  associatedAssets: '',
  notes: '',
  isCustomerRequestCompleted: false,
  templateName: '',
  templateId: '',
  taskAssignedDate: '',
  isShipperCompleted: false,
  isApproved: false,
  packageType: '',
  serviceType: '',
  paymentType: '',
  shippingContactName: '',
  shippingContactNo: '',
  shippingAddress1: '',
  shippingAddress2: '',
  shippingCity: '',
  shippingStateCode: '',
  shippingPostalCode: '',
  shippingCountryCode: '',
  shippingCarrierName: '',
  shippingCarrierAccount: '',
  pickType: '',
  trackingNo: '',
  trackingResponse: '',
  isShippingPrepCompleted: false,
  fedexURL: '',
  taskURL: '',
  pickupOn: '',
  isShippingCompleted: false,
  requestType: '',
  customerName: '',
  isActive: false,
  orderRequest: false,
  isCustomerServiceRequest: false,
  isAssigned: false,
  isExternal: false,
  isServiceCompleted: false,
  isRetured: false,
  assignedTo: '',
  shippingReason: '',
};
